import { render, staticRenderFns } from "./NewBrand.vue?vue&type=template&id=519626d9&scoped=true&"
import script from "./NewBrand.ts?vue&type=script&lang=ts&"
export * from "./NewBrand.ts?vue&type=script&lang=ts&"
import style0 from "./NewBrand.scss?vue&type=style&index=0&id=519626d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519626d9",
  null
  
)

export default component.exports